import { CommonModule } from '@angular/common';
import { Component, OnInit, input, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-image-preview',
    templateUrl: './image-preview.component.html',
    styleUrls: ['./image-preview.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
    ],
})
export class ImagePreviewComponent implements OnInit {
    readonly thumbnail = input<string>();
    readonly fill = input(false);
    readonly image = input<string>();
    readonly style = input<string>();

    readonly loading = signal(true);

    ngOnInit(): void {
        if (this.thumbnail()) {
            this.loading.set(true);
        } else {
            this.loading.set(false);
        }
    }

    loaded(): void {
        this.loading.set(false);
    }
}
